var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedTicketMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.473,
    height: 10.15,
    viewBox: "0 0 13.473 10.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-2024-06-13-at-4.24.08_PM",
    "data-name": "Screenshot-2024-06-13-at-4.24.08\\u202FPM",
    transform: "translate(-66.925 407.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M68.07-407.86a1.5,1.5,0,0,0-.888.617,1.55,1.55,0,0,0-.127.293A5.945,5.945,0,0,0,67-405.49v1.284l.3.014a1,1,0,0,1,.519.116,1.3,1.3,0,0,1,.646.637.87.87,0,0,1,.107.548.87.87,0,0,1-.107.548,1.317,1.317,0,0,1-1.24.759H67v1.29a5.962,5.962,0,0,0,.055,1.463,1.191,1.191,0,0,0,.36.565,1.469,1.469,0,0,0,.678.347c.213.04,10.923.04,11.137,0a1.469,1.469,0,0,0,.678-.347,1.191,1.191,0,0,0,.36-.565,5.946,5.946,0,0,0,.055-1.46v-1.284l-.3-.014a1,1,0,0,1-.519-.116,1.3,1.3,0,0,1-.646-.636.87.87,0,0,1-.107-.548.87.87,0,0,1,.107-.548,1.3,1.3,0,0,1,.646-.637,1,1,0,0,1,.519-.116l.3-.014v-1.284a5.946,5.946,0,0,0-.055-1.46,1.191,1.191,0,0,0-.36-.565,1.469,1.469,0,0,0-.678-.347C79.037-407.9,68.257-407.9,68.07-407.86Zm11.264.574a.945.945,0,0,1,.378.372l.078.145.009,1.023.009,1.023-.208.054a1.77,1.77,0,0,0-.836.472,1.7,1.7,0,0,0-.557,1.321,1.448,1.448,0,0,0,.081.543,1.872,1.872,0,0,0,1.205,1.191,1.969,1.969,0,0,0,.271.071c.037,0,.043.128.035,1.031l-.009,1.029-.078.145a.945.945,0,0,1-.378.372c-.087.048-.389.051-5.672.051s-5.586,0-5.672-.051a.945.945,0,0,1-.378-.372l-.078-.145-.009-1.031c-.009-.9,0-1.029.035-1.029a2.121,2.121,0,0,0,.712-.281,1.838,1.838,0,0,0,.767-.98,1.433,1.433,0,0,0,.075-.557,1.433,1.433,0,0,0-.075-.557,1.882,1.882,0,0,0-1.208-1.191,1.967,1.967,0,0,0-.271-.071c-.037,0-.043-.128-.035-1.031l.009-1.029.078-.142a.923.923,0,0,1,.288-.324c.159-.116.012-.114,5.8-.108C78.939-407.337,79.247-407.334,79.334-407.286Z",
    transform: "translate(0 0)",
    fill: "#cacaca",
    stroke: "#cacaca",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M203.182-301.256l-1.724,1.724-.715-.712c-.392-.389-.741-.724-.779-.744a.27.27,0,0,0-.363.248c0,.092.061.161.836.943.459.464.862.859.9.88.173.089.11.144,2.059-1.8,1.012-1.012,1.848-1.872,1.863-1.912a.261.261,0,0,0-.11-.3C204.949-303.035,205.036-303.11,203.182-301.256Z",
    transform: "translate(-128.776 -101.96)",
    fill: "#cacaca",
    stroke: "#cacaca",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedTicketMenuIcon);
export default __webpack_public_path__ + "static/media/closed-ticket-menu-icon.929c427ca2d6e89188b80b6e958f858d.svg";
export { ForwardRef as ReactComponent };